import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { AppTheme } from '../styles/AppTheme';
import { CommonTheme } from '../styles/Styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles'
import { FormControl } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { Helper } from '../common/helpers/Helper';
import { PhoneNumberHelper } from '../common/helpers/PhoneNumberHelper';
import { PageAnalytics } from '../common/helpers/PageAnalytics';

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: -45,
    top: -45,
    color: 'white',
    '@media(max-width: 767px)': {
      right: -32,
      top: -32,
    },
  },
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant='h6'>{children}</Typography>
      {onClose ? (
        <IconButton aria-label='close' className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

export class ContactComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inProcess: false,
      orderSuccess: false,
      requestItem: {
        name: '',
        email: '',
        phone: '',
        message: ''
      },
      formFieldsValidity: {
        name: true,
        email: true,
        phone: true,
        message: null
      },
      formFieldErrMsg: {
        name: '*Required',
        email: '*Required',
        phone: '*Required',
        message: ''
      },
    }

    this.textFields = [
      {
        id: 'name',
        label: 'Name',
        type: 'text'
      },
      {
        id: 'email',
        label: 'Email Address',
        type: 'email'
      },
      {
        id: 'phone',
        label: 'Phone',
        type: 'phone'
      }
    ]
  }

  componentDidMount() {
    this.sendAnalytics('enquiry-open')
  }

  sendAnalytics = (action) => {
    if (this.props.currentDownloadable) {
      PageAnalytics.gaTrkEvent(
        'general',
        action,
        'DOC_DOWNLOAD',
        null)
    } else if (this.props.groupDeal) {
      PageAnalytics.gaTrkEvent(
        'general',
        action,
        'GRP_DEAL',
        null)
    } else if (this.props.contact) {
      PageAnalytics.gaTrkEvent(
        'general',
        action,
        'CONTACT',
        null)
    } else {
      PageAnalytics.gaTrkEvent(
        'general',
        action,
        'RFQ',
        null)
    }
  }


  getModaltitle = () => {
    if (this.props.currentDownloadable) {
      return 'Fill the details & download'
    } else if (this.props.groupDeal) {
      return this.props.productDetails.title
    } else if (this.props.contact) {
      return 'Contact Us'
    } else {
      return this.props.productDetails.title
    }
  }

  getModalSubtitle = () => {
    if (this.props.currentDownloadable) {
      return null
    } else if (this.props.groupDeal) {
      return 'Join deal'
    } else if (this.props.contact) {
      return null
    } else {
      return 'Request a quote'
    }
  }

  getModalSubtext = () => {
    if (this.props.currentDownloadable) {
      return null
    } else if (this.props.groupDeal) {
      return null
    } else if (this.props.contact) {
      return null
    } else {
      return Helper.getString('signUpOffer')
    }
  }

  getSuccessModalContent = () => {
    if (this.props.currentDownloadable) {
      return 'Download the document'
    } else {
      return 'Thank you for your interest. We will get back to you.'
    }
  }

  getSubmitBtnContent = () => {
    if (this.props.currentDownloadable) {
      return 'SUBMIT'
    } else if (this.props.groupDeal) {
      return 'JOIN DEAL'
    } else if (this.props.contact) {
      return 'SUBMIT'
    } else {
      return 'SEND REQUEST'
    }
  }

  getFieldErrorMsg = (formFieldKey) => {
    if (this.state.formFieldErrMsg[formFieldKey]) {
      return this.state.formFieldErrMsg[formFieldKey]
    }
    return '*Required'
  }

  generateTextField(item) {
    let validity = {};
    validity = this.state.formFieldsValidity;
    return (
      <TextField
        key={item.id}
        onChange={e => this.change(e, item.id)}
        className={css(Styles.textfield)}
        variant='outlined'
        id={item.id}
        label={item.label}
        fullWidth
        value={this.state.requestItem[item.id]}
        type={item.type}
        helperText={validity[item.id] ? '' : this.getFieldErrorMsg(item.id)}
        error={!validity[item.id]}
        InputProps={{
          classes: {
            notchedOutline: css(Styles.oneLineTextBorder)
          },
        }}
      />
    )
  }

  change = (e, id) => {
    this.setState({
      requestItem: { ...this.state.requestItem, [id]: e.target.value }
    });
  }


  validStudentDetails = () => {
    const validity = this.state.formFieldsValidity;
    const item = this.state.requestItem;
    const formFieldErrMsg = this.state.formFieldErrMsg;
    if (!item.name || item.name.length === 0) {
      validity.name = false;
    } else {
      validity.name = true;
    }
    if (!item.email || item.email.length === 0) {
      validity.email = false;
    } else {
      if (!Helper.validEmail(item.email)) {
        validity.email = false;
        formFieldErrMsg.email = 'Not a valid email'
      } else {
        item.email = Helper.validEmail(item.email)
        validity.email = true;
        formFieldErrMsg.email = '*Required'
      }
    }
    if (!item.phone || item.phone.length === 0) {
      validity.phone = false;
    } else {
      if (!PhoneNumberHelper.formatNumberV2(item.phone, 'IN')) {
        validity.phone = false;
        formFieldErrMsg.phone = 'Not a valid phone'
      } else {
        item.phone = PhoneNumberHelper.formatNumberV2(item.phone, 'IN')
        validity.phone = true;
        formFieldErrMsg.phone = '*Required'
      }
    }

    this.setState({
      formFieldsValidity: validity,
      formFieldErrMsg: formFieldErrMsg
    })
    for (const key in validity) {
      if (validity[key] === false) {
        return false
      }
    }
    return true
  }


  sendRequest() {
    if (!this.validStudentDetails()) {
      return false
    }

    this.setState({
      inProcess: true,
      orderErrMsg: null,
    })

    let items = []
    let orderType = 'RFQ'
    if (this.props.groupDeal) {
      orderType = 'GRP_DEAL'
      items = [
        { id: this.props.productDetails.id, title: this.props.productDetails.title },
      ]
    } else if (this.props.currentDownloadable) {
      orderType = 'DOC_DOWNLOAD'
      items = [
        { id: this.props.productDetails.id, title: this.props.productDetails.title },
      ]
    } else if (this.props.contact) {
      orderType = 'CONTACT'
      items = [
        { id: 'CONTACT', title: 'CONTACT' },
      ]
    } else if (this.props.productDetails) {
      orderType = 'RFQ',
      items = [
        { id: this.props.productDetails.id, title: this.props.productDetails.title },
      ]
    }

    const jsonBody = {
      orderType: orderType,
      items: items,
      userInfo: {
        name: this.state.requestItem.name,
        phone: this.state.requestItem.phone,
        email: this.state.requestItem.email,
      }
    }

    if (this.state.requestItem.message && this.state.requestItem.message.length !== 0) {
      jsonBody.userInfo.message = this.state.requestItem.message
    }

    const options = {
      method: 'POST',
      endPoint: ApiHelper.makeUrlPath(['orders']),
      jsonBody: jsonBody,
      authWithKey: true
    }

    ApiHelper.call(options, function (err, data) {
      if (err) {
        this.setState({
          orderErrMsg: Helper.getErrorMsg(err),
          inProcess: false,
        })
        return;
      }

      this.sendAnalytics('enquiry-submit')

      this.setState({
        orderSuccess: true,
        orderErrMsg: null,
        inProcess: false,
      })
    }.bind(this));
  }

  handleModal = () => {
    this.setState({
      orderSuccess: false,
      orderErrMsg: null,
      requestItem: {
        name: '',
        email: '',
        phone: '',
        message: ''
      }
    })
    this.props.handleModal()
  }

  render() {
    return (
      <div>
        <Dialog
          open={this.props.modalVisible}
          onClose={this.handleModal}
          aria-labelledby='form-dialog-title'
          classes={{
            paper: css(Styles.dialog),
          }}>

          <DialogTitle
            className={css(Styles.dialogTitle)}
            id='customized-dialog-title'
            onClose={this.handleModal}>
            {this.getModaltitle()}
          </DialogTitle>

          <p className={css(Styles.dialogSubTitle)}>{this.getModalSubtitle()}</p>

          <p className={css(Styles.dialogSubTitle,Styles.dialogSubText)}>{this.getModalSubtext()}</p>

          <DialogContent className={css(Styles.dialogContent)}>

            {this.state.orderSuccess &&
              <DialogContentText className={css(Styles.textfieldSpec)}>
                {this.getSuccessModalContent()}
              </DialogContentText>
            }

            {!this.state.orderSuccess &&
              <FormControl className={css(Styles.formControl)}>
                {this.textFields.map((item, index) => {
                  return (this.generateTextField(item))
                })}
                <TextField
                  className={css(Styles.textfield)}
                  id='outlined-multiline-static'
                  multiline
                  rows='3'
                  fullWidth
                  onChange={e => this.change(e, 'message')}
                  label='Add a message (optional)'
                  variant='outlined'
                  InputProps={{
                    classes: {
                      notchedOutline: css(Styles.multilineTextBorder)
                    },
                  }}
                />
              </FormControl>
            }
          </DialogContent>

          {!this.state.orderSuccess &&
            <DialogActions className={css(Styles.dialogButtonContainer)}>
              <Button
                onClick={() => this.sendRequest()}
                variant='contained'
                disabled={this.state.inProcess}
                className={css(Styles.sendRequestButton)}>
                {this.getSubmitBtnContent()}
                {this.state.inProcess &&
                  <CircularProgress size={24} className={css(Styles.progressIcon)} />
                }
              </Button>
            </DialogActions>
          }

          {this.state.orderSuccess && this.props.currentDownloadable &&
            <DialogActions className={css(Styles.dialogButtonContainer)}>
              <a
                target='_blank'
                href={this.props.currentDownloadable}
                className={css(Styles.downloadableBtn)}>
                <Button
                  onClick={() => this.handleModal()}
                  variant='contained'
                  disabled={this.state.inProcess}
                  className={css(Styles.sendRequestButton)}>
                  Download document
                </Button>
              </a>
            </DialogActions>
          }
          {this.state.orderErrMsg &&
            <p className={css(Styles.dummyMsgText)}>{this.state.orderErrMsg}</p>
          }
        </Dialog>
      </div>
    )
  }

}

const Styles = StyleSheet.create({
  dummyMsgText: {
    textAlign: 'center',
    margin: 0
  },
  sendRequestButton: {
    backgroundColor: CommonTheme.textColor, //TODO can we apply like this?
    color: CommonTheme.white,
    fontWeight: 'bolder',
    width: '40%',
    alignSelf: 'center',
    '@media(max-width: 1024px)': {
      width: '80%',
      fontSize: 12
    },
  },
  downloadableBtn: {
    textDecoration: 'none',
    marginLeft: 7,
    marginRight: 7,
    width: '100%',
    textAlign: 'center'
  },
  dialogButtonContainer: {
    justifyContent: 'center'
  },
  progressIcon: {
    marginLeft: 5
  },
  multilineTextBorder: {
    borderRadius: CommonTheme.borderRadius * 2
  },
  textfield: {
    margin: '10px 0px',
    '@media(max-width: 767px)': {
      margin: '5px 0px',
    },
  },
  formControl: {
    width: '100%',
  },
  dialog: {
    padding: AppTheme.pagePadding * 4,
    width: '40%',
    overflow: 'unset',
    borderRadius: CommonTheme.borderRadius,
    '@media(max-width: 767px)': {
      width: '100%',
      padding: AppTheme.pagePadding * 2
    },
  },
  textfieldSpec: {
    marginBottom: '10px',
    color: CommonTheme.black,
    '@media(max-width: 767px)': {
      marginBottom: '10px',
    },
  },
  dialogTitle: {
    color: CommonTheme.textColor,
    fontWeight: 'bolder',
    padding: '0px 24px',
    margin: '10px 0px 0px 0px',
    display: 'flex',
    alignItems: 'center',
    '@media(max-width: 767px)': {
      width: '80%',
      padding: '0px 10px',
      margin: '5px 0px 0px 0px',
    },
  },
  dialogSubTitle: {
    color: 'black',
    padding: '0px 24px',
    margin: '10px 0px 0px 0px',
    display: 'flex',
    alignItems: 'center',
    marginTop: 0,
    '@media(max-width: 767px)': {
      width: '80%',
      padding: '0px 10px',
      margin: '5px 0px 0px 0px',
      marginTop: 0,
    },
  },
  dialogSubText: {
    fontSize: 14,
    fontStyle: 'italic',
    marginTop: 5,
    color: AppTheme.primaryColor,
  },
  dialogContent: {
    '@media(max-width: 767px)': {
      padding: '0px 10px'
    }
  },
  oneLineTextBorder: {
    borderRadius: CommonTheme.borderRadius * 3
  },
})


// WEBPACK FOOTER //
// ./src/components/ContactComponent.js